import * as Sentry from '@sentry/browser';

const reportToSentry = (err: Error) => {
  Sentry.captureException(err);
};

export default reportToSentry;
